import { render, staticRenderFns } from "./RequestDetails.vue?vue&type=template&id=1443b9c9&scoped=true"
import script from "./RequestDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RequestDetails.vue?vue&type=style&index=0&id=1443b9c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1443b9c9",
  null
  
)

export default component.exports